module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper",
    staticStyle: {
      "min-height": "870px"
    }
  }, [_c('div', {
    staticClass: "fade-transition ng-scope"
  }, [_c('section', {
    staticClass: "content-header ng-scope"
  }, [_c('h1', [_vm._v("Validação da Proposta")]), _vm._v(" "), _c('b-breadcrumb', {
    attrs: {
      "items": [{
        text: 'Inicial',
        href: '/'
      }, {
        text: 'Validação de Proposta',
        href: '#'
      }, {
        text: 'Primeira Aprovação',
        active: true
      }]
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row",
    attrs: {
      "id": "validaProp"
    }
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h4', [_vm._v("Pré-Análise")]), _vm._v(" "), _c('div', {
    staticClass: "box box-solid"
  }, [_c('div', {
    staticClass: "box-body no-padding"
  }, [_c('ul', {
    staticClass: "nav nav-pills nav-stacked",
    attrs: {
      "id": "filtroPre"
    }
  }, [_c('li', {
    class: {
      'active': _vm.faseAtual === 'primeira'
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.faseAtual = 'primeira'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-hand-pointer-o"
  }), _vm._v("Primeira Aprovação "), _c('span', {
    staticClass: "label label-primary pull-right"
  }, [_vm._v(_vm._s(_vm.quantidadesPorFase.preAnalysisFirstApproval))])])]), _vm._v(" "), (this.$root.authorize('pre-analise-segunda-aprovacao-validar')) ? _c('li', {
    class: {
      'active': _vm.faseAtual === 'segunda'
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.faseAtual = 'segunda'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-hand-peace-o"
  }), _vm._v("Segunda Aprovação "), _c('span', {
    staticClass: "label label-primary pull-right"
  }, [_vm._v(_vm._s(_vm.quantidadesPorFase.preAnalysisSecondApproval))])])]) : _vm._e()])])])])]), _vm._v(" "), (this.$root.authorize('aceite-proposta-validar')) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h4', [_vm._v("Aceite")]), _vm._v(" "), _c('div', {
    staticClass: "box box-solid"
  }, [_c('div', {
    staticClass: "box-body no-padding"
  }, [_c('ul', {
    staticClass: "nav nav-pills nav-stacked",
    attrs: {
      "id": "filtroAceite"
    }
  }, [_c('li', {
    class: {
      'active': _vm.faseAtual === 'aceite'
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.faseAtual = 'aceite'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-hand-pointer-o"
  }), _vm._v("Aprovação "), _c('span', {
    staticClass: "label label-primary pull-right"
  }, [_vm._v(_vm._s(_vm.quantidadesPorFase.acceptanceApproval))])])])])])])])]) : _vm._e(), _vm._v(" "), (this.$root.authorize('analise-aprovacao-validar|analise-pendencia-aprovacao-validar')) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h4', [_vm._v("Análise")]), _vm._v(" "), _c('div', {
    staticClass: "box box-solid"
  }, [_c('div', {
    staticClass: "box-body no-padding"
  }, [_c('ul', {
    staticClass: "nav nav-pills nav-stacked",
    attrs: {
      "id": "filtroAnalise"
    }
  }, [_c('li', {
    class: {
      'active': _vm.faseAtual === 'analise'
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.faseAtual = 'analise'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-hand-pointer-o"
  }), _vm._v("Aprovação "), _c('span', {
    staticClass: "label label-primary pull-right"
  }, [_vm._v(_vm._s(_vm.quantidadesPorFase.analysisApproval + _vm.quantidadesPorFase.analysisPendency))])])])])])])])]) : _vm._e(), _vm._v(" "), (this.$root.authorize('deferimento-aprovacao-validar')) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h4', [_vm._v("Deferimento")]), _vm._v(" "), _c('div', {
    staticClass: "box box-solid"
  }, [_c('div', {
    staticClass: "box-body no-padding"
  }, [_c('ul', {
    staticClass: "nav nav-pills nav-stacked",
    attrs: {
      "id": "filtroDef"
    }
  }, [_c('li', {
    class: {
      'active': _vm.faseAtual === 'deferimento'
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.faseAtual = 'deferimento'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-hand-pointer-o"
  }), _vm._v("Aprovação "), _c('span', {
    staticClass: "label label-primary pull-right"
  }, [_vm._v(_vm._s(_vm.quantidadesPorFase.grantApproval))])])])])])])])]) : _vm._e(), _vm._v(" "), (this.$root.authorize('preparacao-documentos-aprovacao-validar')) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h4', [_vm._v("Preparação de Documentos")]), _vm._v(" "), _c('div', {
    staticClass: "box box-solid"
  }, [_c('div', {
    staticClass: "box-body no-padding"
  }, [_c('ul', {
    staticClass: "nav nav-pills nav-stacked",
    attrs: {
      "id": "filtroPrep"
    }
  }, [_c('li', {
    class: {
      'active': _vm.faseAtual === 'preparacao'
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.faseAtual = 'preparacao'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-hand-pointer-o"
  }), _vm._v("Aprovação "), _c('span', {
    staticClass: "label label-primary pull-right"
  }, [_vm._v(_vm._s(_vm.quantidadesPorFase.documentPreparationApproval))])])])])])])])]) : _vm._e(), _vm._v(" "), (this.$root.authorize('formalizacao-projetos-aprovacao-validar')) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h4', [_vm._v("Formalizar Projetos")]), _vm._v(" "), _c('div', {
    staticClass: "box box-solid"
  }, [_c('div', {
    staticClass: "box-body no-padding"
  }, [_c('ul', {
    staticClass: "nav nav-pills nav-stacked",
    attrs: {
      "id": "filtroForm"
    }
  }, [_c('li', {
    class: {
      'active': _vm.faseAtual === 'formalizacao'
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.faseAtual = 'formalizacao'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-hand-pointer-o"
  }), _vm._v("Aprovação "), _c('span', {
    staticClass: "label label-primary pull-right"
  }, [_vm._v(_vm._s(_vm.quantidadesPorFase.projectFormalizationApproval))])])])])])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-caret-right",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.descricaoFase))]), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right",
    staticStyle: {
      "position": "relative"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "box-title"
  }), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right",
    staticStyle: {
      "position": "relative",
      "margin-right": "10px"
    }
  }, [_c('div', {
    staticClass: "has-feedback"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.table.filter),
      expression: "table.filter"
    }],
    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-empty",
    attrs: {
      "type": "text",
      "placeholder": "Pesquisa..."
    },
    domProps: {
      "value": (_vm.table.filter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.table, "filter", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body no-padding"
  }, [_c('div', {
    staticClass: "mailbox-controls"
  }, [_c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-default btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.filtro.favorite = !_vm.filtro.favorite
      }
    },
    model: {
      value: (_vm.filtro.favorite),
      callback: function($$v) {
        _vm.$set(_vm.filtro, "favorite", $$v)
      },
      expression: "filtro.favorite"
    }
  }, [_c('i', {
    staticClass: "fa fa-star"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.filtro.userId ? _vm.filtro.userId = null : _vm.filtro.userId = _vm.usuarioLogado.id
      }
    },
    model: {
      value: (_vm.filtro.userId),
      callback: function($$v) {
        _vm.$set(_vm.filtro, "userId", $$v)
      },
      expression: "filtro.userId"
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  })])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onSearch
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  })]), _vm._v(" "), _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "striped": "",
      "stacked": "md",
      "bordered": _vm.table.bordered,
      "items": _vm.table.items,
      "fields": _vm.table.fields,
      "filter": _vm.table.filter,
      "current-page": _vm.table.currentPage,
      "per-page": _vm.table.perPage,
      "sort-by": _vm.table.sortBy,
      "sort-desc": _vm.table.sortDesc,
      "empty-text": "Nenhum registro encontrado"
    },
    on: {
      "filtered": _vm.onFiltered,
      "update:sortBy": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sort-by": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sortDesc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      },
      "update:sort-desc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "favorite",
      fn: function(row) {
        return [_c('i', {
          class: ['fa ', row.value ? 'fa-star text-warning' : 'fa-star-o'],
          attrs: {
            "aria-hidden": "true"
          },
          on: {
            "click": function($event) {
              return _vm.onFavorite(row.item)
            }
          }
        })]
      }
    }, {
      key: "proposta",
      fn: function(row) {
        return [_c('div', {}, [(row.item.simplificado > '0') ? _c('div', [_c('b', [_vm._v(_vm._s(row.item.simplificado))]), _c('br')]) : _vm._e(), _vm._v("\n                          " + _vm._s(row.item.companyName) + "\n                        "), _c('div', [_vm._v("\n                          " + _vm._s(row.item.nomeProposta) + "\n                        ")])])]
      }
    }, {
      key: "createdAt",
      fn: function(row) {
        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "L")))]
      }
    }, {
      key: "userName",
      fn: function(row) {
        return [(row.value) ? _c('span', {
          staticStyle: {
            "font-weight": "bold"
          }
        }, [_vm._v(_vm._s(row.value))]) : _c('span', [_vm._v("Aguardando atendimento")])]
      }
    }, {
      key: "actions",
      fn: function(row) {
        return [_c('div', [_c('div', {
          staticClass: "btn-group"
        }, [_c('button', {
          staticClass: "btn btn-default",
          attrs: {
            "data-toggle": "dropdown",
            "aria-haspopup": "true",
            "aria-expanded": "false"
          }
        }, [_c('i', {
          staticClass: "fa fa-ellipsis-h"
        })]), _vm._v(" "), _c('ul', {
          staticClass: "dropdown-menu dropdown-menu-right",
          attrs: {
            "role": "menu",
            "aria-labelledby": "new-register"
          }
        }, [_c('li', [_c('a', {
          attrs: {
            "href": "#"
          }
        }, [_c('i', {
          staticClass: "fa fa-eye",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Ver mais")])]), _vm._v(" "), (_vm.usuarioLogado.id !== row.item.userId) ? _c('li', {
          staticClass: "ng-scope"
        }, [_c('a', {
          attrs: {
            "href": "javascript:void(0)"
          },
          on: {
            "click": function($event) {
              return _vm.onAssign(row.item)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-user",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Atribuir a mim")])]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.id !== row.item.userId) ? _c('li', {
          staticClass: "ng-scope"
        }, [_c('a', {
          attrs: {
            "href": "javascript:void(0)"
          },
          on: {
            "click": function($event) {
              return _vm.onAssignAndDo(row.item)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-arrow-circle-right",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Atribuir e Fazer")])]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.id === row.item.userId) ? _c('li', [_c('a', {
          attrs: {
            "href": "javascript:void(0)"
          },
          on: {
            "click": function($event) {
              return _vm.onUnassign(row.item)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-user-times",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Devolver")])]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.id === row.item.userId) ? _c('li', {
          staticClass: "divider",
          attrs: {
            "role": "separator"
          }
        }) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.id === row.item.userId) ? _c('li', [_c('router-link', {
          attrs: {
            "to": {
              name: _vm.rota1,
              params: {
                id: row.item.id
              }
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-play-circle",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Fazer")])], 1) : _vm._e()])])])]
      }
    }])
  }), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "6",
      "right": ""
    }
  }, [_c('b-pagination', {
    staticClass: "my-3",
    attrs: {
      "total-rows": _vm.table.totalRows,
      "per-page": _vm.table.perPage
    },
    model: {
      value: (_vm.table.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.table, "currentPage", $$v)
      },
      expression: "table.currentPage"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loadingShow),
      expression: "loadingShow"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })])], 1)]), _vm._v(" "), (_vm.faseAtual === 'aceite' || _vm.faseAtual === 'analise') ? _c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-caret-right",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.faseAtual === 'aceite' ? 'Aceite - Recusadas para Ajustes' : 'Análise - Pendências'))]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h3', {
    staticClass: "box-title"
  }), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right",
    staticStyle: {
      "position": "relative",
      "margin-right": "10px"
    }
  }, [_c('div', {
    staticClass: "has-feedback"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.table.filter),
      expression: "table.filter"
    }],
    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-empty",
    attrs: {
      "type": "text",
      "placeholder": "Pesquisa..."
    },
    domProps: {
      "value": (_vm.table.filter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.table, "filter", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body no-padding"
  }, [_c('div', {
    staticClass: "mailbox-controls"
  }, [_c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-default btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.filtro.favorite = !_vm.filtro.favorite
      }
    },
    model: {
      value: (_vm.filtro.favorite),
      callback: function($$v) {
        _vm.$set(_vm.filtro, "favorite", $$v)
      },
      expression: "filtro.favorite"
    }
  }, [_c('i', {
    staticClass: "fa fa-star"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.filtro.userId ? _vm.filtro.userId = null : _vm.filtro.userId = _vm.usuarioLogado.id
      }
    },
    model: {
      value: (_vm.filtro.userId),
      callback: function($$v) {
        _vm.$set(_vm.filtro, "userId", $$v)
      },
      expression: "filtro.userId"
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  })])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onSearch
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  })]), _vm._v(" "), _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "striped": "",
      "stacked": "md",
      "bordered": _vm.table2.bordered,
      "items": _vm.table2.items,
      "fields": _vm.table2.fields,
      "filter": _vm.table2.filter,
      "current-page": _vm.table2.currentPage,
      "per-page": _vm.table2.perPage,
      "sort-by": _vm.table2.sortBy,
      "sort-desc": _vm.table2.sortDesc,
      "empty-text": "Nenhum registro encontrado"
    },
    on: {
      "filtered": _vm.onFilteredRejeitados,
      "update:sortBy": function($event) {
        return _vm.$set(_vm.table2, "sortBy", $event)
      },
      "update:sort-by": function($event) {
        return _vm.$set(_vm.table2, "sortBy", $event)
      },
      "update:sortDesc": function($event) {
        return _vm.$set(_vm.table2, "sortDesc", $event)
      },
      "update:sort-desc": function($event) {
        return _vm.$set(_vm.table2, "sortDesc", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "favorite",
      fn: function(row) {
        return [_c('i', {
          class: ['fa ', row.value ? 'fa-star text-warning' : 'fa-star-o'],
          attrs: {
            "aria-hidden": "true"
          },
          on: {
            "click": function($event) {
              return _vm.onFavorite(row.item)
            }
          }
        })]
      }
    }, {
      key: "proposta",
      fn: function(row) {
        return [_c('div', {}, [(row.item.simplificado > '0') ? _c('div', [_c('b', [_vm._v(_vm._s(row.item.simplificado))]), _c('br')]) : _vm._e(), _vm._v("\n                          " + _vm._s(row.item.companyName) + "\n                          "), _c('div', [_vm._v("\n                            " + _vm._s(row.item.nomeProposta) + "\n                          ")])])]
      }
    }, {
      key: "createdAt",
      fn: function(row) {
        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "L")))]
      }
    }, {
      key: "userName",
      fn: function(row) {
        return [(row.value) ? _c('span', {
          staticStyle: {
            "font-weight": "bold"
          }
        }, [_vm._v(_vm._s(row.value))]) : _c('span', [_vm._v("Aguardando atendimento")])]
      }
    }, {
      key: "actions",
      fn: function(row) {
        return [_c('div', [_c('div', {
          staticClass: "btn-group"
        }, [_c('button', {
          staticClass: "btn btn-default",
          attrs: {
            "data-toggle": "dropdown",
            "aria-haspopup": "true",
            "aria-expanded": "false"
          }
        }, [_c('i', {
          staticClass: "fa fa-ellipsis-h"
        })]), _vm._v(" "), _c('ul', {
          staticClass: "dropdown-menu dropdown-menu-right",
          attrs: {
            "role": "menu",
            "aria-labelledby": "new-register"
          }
        }, [_c('li', [_c('a', {
          attrs: {
            "href": "#"
          }
        }, [_c('i', {
          staticClass: "fa fa-eye",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Ver mais")])]), _vm._v(" "), (_vm.usuarioLogado.id !== row.item.userId) ? _c('li', {
          staticClass: "ng-scope"
        }, [_c('a', {
          attrs: {
            "href": "javascript:void(0)"
          },
          on: {
            "click": function($event) {
              return _vm.onAssign(row.item)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-user",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Atribuir a mim")])]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.id !== row.item.userId) ? _c('li', {
          staticClass: "ng-scope"
        }, [_c('a', {
          attrs: {
            "href": "javascript:void(0)"
          },
          on: {
            "click": function($event) {
              return _vm.onAssignAndDo(row.item)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-user",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Atribuir e Fazer")])]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.id === row.item.userId) ? _c('li', [_c('a', {
          attrs: {
            "href": "javascript:void(0)"
          },
          on: {
            "click": function($event) {
              return _vm.onUnassign(row.item)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-user-times",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Devolver")])]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.id === row.item.userId) ? _c('li', {
          staticClass: "divider",
          attrs: {
            "role": "separator"
          }
        }) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.id === row.item.userId) ? _c('li', [_c('router-link', {
          attrs: {
            "to": {
              name: 'primeira-aprovacao',
              params: {
                id: row.item.id
              }
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-play-circle",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Fazer")])], 1) : _vm._e()])])])]
      }
    }], null, false, 3903324717)
  }), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "6",
      "right": ""
    }
  }, [_c('b-pagination', {
    staticClass: "my-3",
    attrs: {
      "total-rows": _vm.table2.totalRows,
      "per-page": _vm.table2.perPage
    },
    model: {
      value: (_vm.table2.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.table2, "currentPage", $$v)
      },
      expression: "table2.currentPage"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loadingShow),
      expression: "loadingShow"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })])], 1)]) : _vm._e()])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-tools pull-right",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "has-feedback"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-93cc172a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/validação/ListaValidacaoProposta.vue
// module id = 2045
// module chunks = 1